import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesFiscal() {
  const { user } = useContext(AuthContext);

  const secciones = [
    { section: "Facturación", items: [
      { label: "Facturas", icon: "fas fa-file-invoice-dollar", color: "#7c3aed", href: "/ListadoFacturas", enabled: !!(user.menu_fiscal && user.facturasFiscal) },
      { label: "Complementos Pagos", icon: "fas fa-money-bill-wave", color: "#7c3aed", href: "/ListadoComplementosPago", enabled: !!(user.menu_fiscal && user.compPagosFiscal) },
      { label: "Notas de Credito", icon: "fas fa-money-check-alt", color: "#7c3aed", href: "/ListadoNotasCredito", enabled: !!(user.menu_fiscal && user.notasCreditoFiscal) },
      { label: "Devoluciones", icon: "fas fa-undo-alt", color: "#7c3aed", href: "/ListadoDevolucionesFiscal", enabled: !!(user.menu_fiscal && user.devolucionesFiscal) },
      { label: "Abonos Facturas", icon: "fas fa-money-bill-wave", color: "#7c3aed", href: "/ListadoAbonosFacturas", enabled: !!(user.menu_fiscal && user.compPagosFiscal) },
    ]},
    { section: "Configuración", items: [
      { label: "Registrar FIEL", icon: "fas fa-file-alt", color: "#0d9488", href: "/RegistrarEmpresas", enabled: !!(user.menu_fiscal) },
      { label: "Estado Cuenta", icon: "fas fa-file-invoice-dollar", color: "#0d9488", href: "/EstadoCuentaK", enabled: !!(user.menu_fiscal) },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Fiscal"
      descripcion="Facturación y complementos"
      icono="fas fa-file-invoice-dollar"
      color="#7c3aed"
      secciones={secciones}
    />
  );
}

export default BotonesFiscal;
